import { Box , Typography } from '@mui/material';
import { IconCircleCheck, IconCircleX, IconX } from '@tabler/icons-react';
import { toast } from 'react-toastify';

export const showRestoreToast = (
  message,
  toastWidth,
  textWidth,
  backgroundColor,
  error = false,
) => {
  const isMobileView = typeof window !== 'undefined' && window.innerWidth <= 767;
  const isMobileSuccessToast = isMobileView && !error;
  const toastContent = ({ closeToast }) => (
    <Box
      sx={{
        display: 'flex',
        alignItems: isMobileSuccessToast ? 'flex-start' : 'center',
        justifyContent: isMobileSuccessToast ? 'flex-start' : 'space-between',
        gap: isMobileSuccessToast ? '16px' : '24px',
        width: isMobileSuccessToast ? '288px' : isMobileView ? 'calc(100vw - 32px)' : toastWidth,
        maxWidth: isMobileSuccessToast ? '288px' : isMobileView ? 'calc(100vw - 32px)' : undefined,
        height: isMobileSuccessToast ? 'auto' : error ? '56px' : '52px',
        padding: '16px',
        boxSizing: 'border-box',
        background: isMobileSuccessToast ? 'var(--BI-System-Colors-Success-Dark, #005C2C)' : backgroundColor,
        borderRadius: '16px',
        position: isMobileSuccessToast ? 'absolute' : 'relative',
        left: isMobileSuccessToast ? '16px' : undefined,
        bottom: isMobileSuccessToast ? '40px' : undefined
      }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          flex: 1,
          minWidth: 0
        }}>
        <Box
          sx={{
            width: '20px',
            height: '20px',
            minWidth: '20px',
            minHeight: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}
        >
        {error 
         ? <IconCircleX color="#FFFFFF" size={20} />
         : <IconCircleCheck color="#FFFFFF" size={20} />
         }
        </Box>
        
        <Typography
          style={{
            color: '#FFFFFF',
            fontSize: '14px',
            fontWeight: 600,
            lineHeight: '22.4px',
            fontFamily: 'Noto Sans',
            width: isMobileView ? '100%' : textWidth,
            margin: 0,
            whiteSpace: isMobileView ? 'normal' : 'nowrap',
            overFlow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: 0,
          }}>
          {message}
        </Typography>
      </Box>
      <Box
        sx={{
          width: '20px',
          height: '20px',
          minWidth: '20px',
          minHeight: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          cursor: 'pointer'
        }}
        onClick={closeToast}
        >
      <IconX
        color="#ffffff"
        size={20}
        strokeWidth={2}
      />
      </Box> 
    </Box>
  );
  const toastId = 'restore-toast';
  const toastOption = {
    toastId: toastId,
    position: isMobileView ? 'bottom-center' : 'top-center',
    autoClose: 5000,
    hideProgressBar: true,
    closeButton: false,
    icon: false,
    style: {
      padding: 0,
      margin: 0,
      background: 'transparent',
      boxShadow: 'none',
      minHeight: 'unset',
      borderRadius: '8px'
    }
  };
  if (toast.isActive(toastId)) {
    toast.update(toastId, {
      ...toastOption,
      render: toastContent,
      autoClose: 5000
    });
  } else {
    toast(toastContent, {...toastOption, toastId});
  }
};
